import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
const BASE_URI = 'app-users/v1/teams';
export const fetchTeams = () => {
  return http.get(BASE_URI).then(fromJS);
};